<!--快捷买币-->
<template>
	<div>
		<div class="fast-buy-title">
			<h3 class="bit-center-wrap">
				<div class="left-con">快捷買幣 </div>
				<div class="right-con" @click="$nav.go('/pc/buyingCoinsOrder')">
					<img style="margin-right: 6px;" src="@/assets/img-pc/purchase_1.svg" alt="" />歷史帳單
				</div>
			</h3>
		</div>

		<div class="basepage bit-center-wrap">
			<div class="left">
				<div class="text1">快速交易，便捷高效</div>
				<img class="banner" src="@/assets/img-pc/purchase_2.png" alt="" />
			</div>
			<div class="right">
				<div class="segment">
					<div class="item active">
						<div class="title">購買</div>
					</div>
					<div class="item">
						<div class="title">出售</div>
					</div>
				</div>

				<div class="content">
					<div class="input-item">
						<div class="input-left">
							<div class="input-text">我要支付</div>
							<input placeholder="請輸入" class="input-input">
						</div>
						<div class="input-coin hand">
							<img src="https://v3.ptdemot.bio/public/05576da47940429fbcb367c7eead909f.png"
								class="coin-icon">
							<div class="coin-text">ABPAY</div>
						</div>
					</div>
					<div class="tip1">1-100000000 ABPAY</div>

					<div class="input-item" style="margin-top: 30px;">
						<div class="input-left">
							<div class="input-text">我將收到</div>
							<input placeholder="請輸入" class="input-input">
						</div>
						<div class="input-coin hand">
							<img src="@/assets/img-pc/purchase_3.png" class="coin-icon">
							<div class="coin-text">USDT</div>
						</div>
					</div>
					<div class="tip1">1 ≈ ABPAY </div>

					<div class="submit">購買</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	components: {},
	data() {
		return {};
	},
	mounted() {
		// this.$message({
		// 	showClose: true,
		// 	message: '这是一条消息提示',
		// 	duration: 0,
		// 	type: 'error',
		// });
	},
	beforeUnmount() { },
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.fast-buy-title {
	border-bottom: 1px solid #2c2c3e;

	.bit-center-wrap {
		height: 80px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #fff;
		width: var(--min-width);
		max-width: 90%;
		margin: 0 auto;

		.left-con {
			font-size: 24px;
		}

		.right-con {
			font-size: 16px;
			display: flex;
			align-items: center;
			cursor: pointer;
		}
	}
}



.basepage {
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: var(--min-width);
	max-width: 90%;
	margin: 80px auto;

	.left {
		.text1 {
			font-weight: 350;
			font-size: 50px;
			line-height: 70px;
		}

		.banner {
			width: 580px;
			height: 530px;
		}
	}

	.right {
		width: 700px;
		height: 620px;
		margin-left: 50px;
		border-radius: 12px;
		background: #1f1f2f;
		box-shadow: 0 10px 30px rgba(0, 0, 0, .050980392156862744);
		position: relative;
		z-index: 2;

		.segment {
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 6px;
			overflow: hidden;
			cursor: pointer;

			.item {
				width: 50%;
				height: 100px;
				position: relative;
				cursor: pointer;

				.title {
					position: absolute;
					z-index: 1;
					line-height: 100px;
					width: 100%;
					height: 50px;
					color: var(--font-color-main);
					text-align: center;
					cursor: pointer;
				}
			}

			.active {
				color: #00a4d8;
				background: #141422;
			}
		}

		.content {
			padding: 60px 40px;

			.input-item {
				height: 100px;
				border: 1px solid #2c2c3e;
				background-color: #000;
				border-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				position: relative;

				.input-left {
					display: flex;
					height: 100px;
					flex-direction: column;
					align-items: flex-start;
					justify-content: center;

					.input-text {
						margin-top: 10px;
						margin-left: 20px;
						font-weight: 350;
						font-size: 14px;
						line-height: 21px;
						color: var(--font-color-main);
					}

					.input-input {
						margin-left: 20px;
						margin-top: 2px;
						width: 400px;
						height: 33px;
						font-weight: 350;
						font-size: 22px;
						line-height: 33px;
						color: var(--font-color-main);
						background: #ff000000;
						border: 0px;
					}
				}
			}

			.input-coin {
				margin-right: 12px;
				min-width: 126px;
				height: 53px;
				background: var(--content-bg);
				border-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px solid #3c4974;

				.coin-icon {
					width: 24px;
					height: 24px;
					margin-left: 10px;
					margin-right: 9px;
				}

				.coin-text {
					font-weight: 350;
					font-size: 18px;
					line-height: 27px;
					color: var(--font-color-main);
				}
			}

			.tip1 {
				font-weight: 400;
				font-size: 12px;
				line-height: 18px;
				color: #b0bde9;
			}
		}
	}
}

.submit {
	margin-top: 50px;
	border-radius: 100px;
	width: 100%;
	height: 60px;
	font-weight: 350;
	font-size: 20px;
	background: #00f0ff;
	color: #000;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>